export const StringToNumber = (value) => {
    return parseInt(value);
}
export const StringToNumberOrDouble = (value) => {
    return parseFloat(value);
}